import { useMemo } from 'react';

import useAuth from 'hooks/useAuth';
import { getModuleAccess, parsePermissionsFromUser, type PermissionIndex } from 'utils/permissionsFromUser';

export type ModuleAccess = {
  canCreate: boolean;
  canRead: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  isUnrestricted: boolean;
};

export function usePermissionIndex(): PermissionIndex | null {
  const { user } = useAuth();
  return useMemo(() => parsePermissionsFromUser(user), [user]);
}

/** Resolved CRUD flags for an API `module` slug (e.g. `users`, `notification`). */
export default function useModuleAccess(module: string): ModuleAccess {
  const index = usePermissionIndex();
  return useMemo(() => {
    const unrestricted = index === null;
    const row = getModuleAccess(index, module);
    return {
      canCreate: row.create,
      canRead: row.read,
      canUpdate: row.update,
      canDelete: row.delete,
      isUnrestricted: unrestricted,
    };
  }, [index, module]);
}
